export default __webpack_public_path__ + "static/media/icon-milgrain-options.919ec153.svg";